import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from 'stylesheets/components/errors/carousel_error.module';

export function CarouselError(props) {
  return (
    <div
      className={classNames(styles.carouselError, styles[`${props.type}-${props.slideSize}`], {
        [styles.small]: props.small,
      })}
    >
      <p className={styles.carouselErrorText}>
        Sorry, looks like we couldn&apos;t load this content. Please try
        <a className={styles.carouselErrorLink} href='#' onClick={() => window.location.reload()}>
          refreshing the page
        </a>
        .
      </p>
    </div>
  );
}

CarouselError.propTypes = {
  type: PropTypes.oneOf(['bookCard', 'coverImage']).isRequired,
  slideSize: PropTypes.number,
  small: PropTypes.bool,
};

CarouselError.defaultProps = {
  small: false,
};
